import Footer from "./components/Footer";
import KiteTypes from "./components/KiteTypes";
import Navbar from "./components/Navbar";
import cover from "../src/images/cover2.png"
import "../src/components/styles.scss"

function App() {
  return (
    <div className="App">
      <Navbar />
      <div className="cover">
        <h1 className="header-text">Wholesale & Retail, All Kids Fancy Kites, Maanja(Mono Gold, Tun Tun, Double Blade, Gajar & Special Maanja Available), Paper Kites Available in all sizes - 2-Pound, 1-Pound, 1/2-Pound.Contact us on <span className="contact-no"> call/whatsapp - 7097926412</span> </h1>
        <img src={cover} alt="cover" className="cover-img"/>
      </div>
      <KiteTypes />
      <Footer />
    </div>
  );
}

export default App;
